import React from 'react';

const LOGOS = [
  { src: '/mtc.png', alt: 'MIT Martin Trust Center' },
  { src: '/deltav.png', alt: 'deltaV' },
  { src: '/harvardchan.png', alt: 'Harvard Chan' },
  { src: '/a16z.png', alt: 'a16z speedrun' },
  { src: '/mec.png', alt: 'MEC' },
  { src: '/mit100k.png', alt: 'MIT 100K' },
  { src: '/hms.webp', alt: 'Harvard Medical School' },
  { src: '/sandbox.png', alt: 'Sandbox' },
];

// Enough copies that half the track is always wider than any viewport, so the
// -50% loop never exposes a gap. Only the first copy is read by assistive tech.
const COPIES = 6;

const LogoMarquee = () => (
  <section className="logo-marquee-section">
    <p className="logo-marquee-label">
      Backed by leading institutions in healthcare and technology
    </p>
    <div className="logo-marquee">
      <div className="logo-marquee-track">
        {Array.from({ length: COPIES }, (_, group) => (
          <div className="logo-marquee-group" key={group} aria-hidden={group !== 0}>
            {LOGOS.map((logo) => (
              <img key={logo.src} src={logo.src} alt={group === 0 ? logo.alt : ''} />
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LogoMarquee;
